import { Controller } from "stimulus"

export default class extends Controller
  initialize: ->
    new App.Views.DirectPostFormView el: $(@element)
    new App.Views.DirectPostImageCropWidthAndHeightFieldAssignmentView el: $(@element)
